// @flow

import buildCreateSaleIfMissingAndAddSaleItem from './action/addSaleItemAction';
import buildOpenSale from './action/openSaleAction';
import buildNewSale from './action/newSaleAction';

import RootContainer from './components/container/RootContainer';
import ManageRetailSaleContainer from './components/container/ManageRetailSaleContainer';

import createRetailStockInventoryAndPriceTableColumn from './components/table/RetailStockInventoryAndPriceTableColumn';

import retailStockInventoryAndPriceTableConfiguration from './components/configuration/retailStockInventoryAndPriceTableConfiguration';
import RetailStockInventoryAndPriceTableFilter from './components/table/RetailStockInventoryAndPriceTableFilter';

import currentRetailSaleLinesTableConfiguration from './components/configuration/currentRetailSaleLinesTableConfiguration';

import openRetailSalesTableConfiguration from './components/configuration/openRetailSalesTableConfiguration';
import paymentTransactionsTableConfiguration from './components/configuration/paymentTransactionsTableConfiguration';

import createRetailSaleLineTableColumn from './components/table/RetailSaleLineTableColumn';
import createOpenRetailSaleTableCellRenderer from './components/table/OpenRetailSaleTableColumn';

import RetailSaleHeaderForm from './components/form/RetailSaleHeaderForm';

import RetailSaleConfigurationComboBox from './components/form/RetailSaleConfigurationComboBox';

import RetailSalePaymentForm from './components/form/RetailSalePaymentForm';

import createPaymentTransactionTableColumn from './components/table/PaymentTransactionTableColumn';

import createOpenRetailSaleTableToolbarButtons from './components/table/OpenRetailSaleTableToolbarButtons';

export const components = {
    'container:root': RootContainer,
    'container:manageRetailSaleContainer': ManageRetailSaleContainer,

    'action:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.listStocksTable.action.onAddItem': buildCreateSaleIfMissingAndAddSaleItem,
    'tableColumn:retailStockInventoryAndPrice': createRetailStockInventoryAndPriceTableColumn,

    'action:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.openRetailSalesTable.action.onRowClick': buildOpenSale,
    'action:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.openRetailSalesTable.action.newSale': buildNewSale,

    'viewOnlyForm:currentRetailSaleHeaderForm': RetailSaleHeaderForm,

    'tableConfiguration:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.listStocksTable': retailStockInventoryAndPriceTableConfiguration,
    'tableFilter:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.listStocksTable.filter': RetailStockInventoryAndPriceTableFilter,

    'tableConfiguration:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.paymentTransactionsTable': paymentTransactionsTableConfiguration,

    'tableConfiguration:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.currentRetailSaleLinesTable': currentRetailSaleLinesTableConfiguration,

    'tableConfiguration:trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.openRetailSalesTable': openRetailSalesTableConfiguration,

    'tableColumn:openRetailSale': createOpenRetailSaleTableCellRenderer,

    'tableColumn:retailSaleLine': createRetailSaleLineTableColumn,

    'formPaneField:retailSaleConfiguration': RetailSaleConfigurationComboBox,

    'editableForm:currentRetailSalePaymentForm': RetailSalePaymentForm,

    'tableColumn:paymentTransaction': createPaymentTransactionTableColumn,

    'tableToolbarButtons:openRetailSalesTable': createOpenRetailSaleTableToolbarButtons
}
